import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoyaltyWalletRequest } from '../../service/loyalty-wallet.request';

export const fetchBalance = createAsyncThunk(
	'loyalty-wallet/fetchBalance',
	async (_, { rejectWithValue }) => {
		try {
			const req = new LoyaltyWalletRequest();
			const res = await req.getMyWallet();
			return res.data?.data;
		} catch (error: any) {
			console.log('error', error?.response?.data);
			return rejectWithValue(error?.response?.data);
		}
	}
);

interface LoyaltyWalletState {
	balance: string;
}

const initialState = { balance: '0' } as LoyaltyWalletState;

const loyaltyWalletSlice = createSlice({
	name: 'loyaltyWallet',
	initialState,
	reducers: {
		setLoyaltyBalance(state, action: PayloadAction<string>) {
			state.balance = action.payload;
			return state;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchBalance.fulfilled, (state, action) => {
			state.balance = action.payload?.availableBalance;
		});
	},
});

export const { setLoyaltyBalance } = loyaltyWalletSlice.actions;
export default loyaltyWalletSlice.reducer;
